export { GalaxySnackbarModule } from './src/snackbar.module';
export { SnackbarService } from './src/snackbar.service';
